module.exports = __webpack_public_path__ + "img/vacance4.8ca8cee8.jpg";